export const contactTypes: any[] = [
  {
    field: "siteContact",
    level: "site",
    identifier: "siteContactId",
    name: "Site Contact",
    helpString: "This is the overall site contact to work with when scheduling order deliveries and installations.",
  },
  {
    field: "deliveryContact",
    level: "site",
    identifier: "deliveryContactId",
    name: "Delivery Contact",
    helpString: "For smaller sites, this contact can sometimes be the same as Site Contact. For larger sites, " +
      "this may be a loading dock manager or deliveries scheduler.  ",
  },
  {
    field: "installationContact",
    level: "site",
    identifier: "installationContactId",
    name: "Installation Contact",
    helpString: "This is the contact responsible for installation at the site.",
  },
  {
    field: "managerContact",
    level: "site",
    identifier: "managerContactId",
    name: "Manager Contact",
    helpString: "Larger deals may have this type of contact that need to be kept informed on project status.",
  },
  {
    field: "alternateContact",
    level: "site",
    identifier: "alternateContactId",
    name: "Alternate Contact",
    helpString: "Alternate contact can be used to associate an additional point of contact for the site.",
  },
  {
    field: "serviceContact",
    level: "site",
    identifier: "breakfixContactId",
    name: "Service Delivery Contact",
    helpString: "This is the contact responsible for scheduling break fix services for the device or site.",
  },
  {
    field: "tonerContact",
    level: "site",
    identifier: "tonerContactId",
    name: "Consumable Contact",
    helpString: "If Consumables are priced into the contract, this contact is required. Consumables will be shipped " +
      "to their attention. If no such contact is available for this Site, select an associated HP account. ",
  },
  {
    field: "orderStatusNotification1",
    level: "site",
    identifier: "orderStatusNot1ContactId",
    name: "Order Status 1 Contact",
    helpString: "If Consumables are priced into the contract, this contact is required. This is the contact who " +
      "receives order status email notifications.  If no such contact is available for this Site, select an " +
      "associated HP account.",
  },
  {
    field: "orderStatusNotification2",
    level: "site",
    identifier: "orderStatusNot2ContactId",
    name: "Order Status 2 Contact",
    helpString: "Option for additional contacts to receive order status email notifications.",
  },
  {
    field: "orderStatusNotification3",
    level: "site",
    identifier: "orderStatusNot3ContactId",
    name: "Order Status 3 Contact",
    helpString: "Option for additional contacts to receive order status email notifications.",
  },
  {
    field: "itContact",
    level: "site",
    identifier: "itContactId",
    name: "IT Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
  },
  {
    field: "logisticContact",
    level: "site",
    identifier: "logisticContactId",
    name: "Logistic Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
  },
  {
    field: "billToContact",
    level: "contractualContact",
    identifier: "billToContactId",
    name: "Bill-To Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "billTo",
  },
  {
    field: "invoiceContact",
    level: "contractualContact",
    identifier: "invoiceContactId",
    name: "Invoice Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "invoice",
  },
  {
    field: "hpInvoiceContact",
    level: "contractualContact",
    identifier: "hpInvoiceContactId",
    name: "HP Invoice Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "hpInvoice",
  },
  {
    field: "hpSalesRepContact",
    level: "contractualContact",
    identifier: "hpSalesRepContactId",
    name: "HP Sales Rep Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "sales",
  },
  {
    field: "hpContractAdminContact",
    level: "contractualContact",
    identifier: "hpContractAdminContactId",
    name: "HP Contract Admin",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "contractAdmin",
  },
  {
    field: "hpAccDeliveryMgrContact",
    level: "contractualContact",
    identifier: "hpAccDeliveryMgrContactId",
    name: "HP Client Manager Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "accDelMgr",
  },
  {
    field: "billToContact",
    level: "site",
    identifier: "billToContactId",
    name: "Bill-To Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "billTo",
  },
  {
    field: "invoiceContact",
    level: "site",
    identifier: "invoiceContactId",
    name: "Invoice Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "invoice",
  },
  {
    field: "hpInvoiceContact",
    level: "site",
    identifier: "hpInvoiceContactId",
    name: "HP Invoice Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "hpInvoice",
  },
  {
    field: "hpSalesRepContact",
    level: "site",
    identifier: "hpSalesRepContactId",
    name: "HP Sales Rep Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "sales",
  },
  {
    field: "hpContractAdminContact",
    level: "site",
    identifier: "hpContractAdminContactId",
    name: "HP Contract Admin",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "contractAdmin",
  },
  {
    field: "hpAccDeliveryMgrContact",
    level: "site",
    identifier: "hpAccDeliveryMgrContactId",
    name: "HP Client Manager Contact",
    helpString: "Larger deals may have this specific contact that need to be kept informed on project status.",
    type: "accDelMgr",
  },
];
